function checkRestrictedQuantities(cart = false) {
  const quantityInputs = document.querySelectorAll(".line-item__actions line-item-quantity input");
  quantityInputs.forEach(async (input) => {
    const line_item = cart ? cart.items.find((item) => item.key == input.dataset.lineKey) : false;
    const value = line_item ? line_item.quantity : parseInt(input.value, 10);
    const max = parseInt(input.max, 10);
    if (value > max) {
      const targetQuantity = input.max;
      const lineKey = input.dataset.lineKey;
      const lineItem = input.closest("line-item");
      lineItem?.dispatchEvent(
        new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity },
        })
      );
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: targetQuantity,
            sections: sectionsToBundle,
          }),
        })
      ).json();
      const lineItemAfterChange = cartContent["items"].filter(
        (lineItem2) => lineItem2["key"] === lineKey
      );
      lineItem?.dispatchEvent(
        new CustomEvent("line-item:change", {
          bubbles: true,
          detail: {
            quantity:
              lineItemAfterChange.length === 0
                ? 0
                : lineItemAfterChange[0]["quantity"],
            cart: cartContent,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: cartContent,
          },
        })
      );
    }
  });
}

function checkResctrictedProducts(cart = false) {
  const restrictedArray = [42519543054572];
  const lineItems = document.querySelectorAll(".line-item");
  let lineKeys;
  if (cart) {
    lineKeys = [...new Set(cart.items.map(item => item.id))];
  } else {
    const lineItemArray = new Array(...lineItems);
    lineKeys = [...new Set(lineItemArray.map(item => parseInt(item.dataset.itemId, 10)))]
  }
  const lineItemSize = lineKeys.length;
  if (lineItemSize == 1) {
    lineItems.forEach(async (item) => {
      const id = parseInt(item.dataset.itemId, 10);
      if (restrictedArray.includes(id)) {
        const input = item.querySelector(".line-item__actions line-item-quantity input");
        const line_item = cart ? cart.items.find((item) => item.key == input.dataset.lineKey) : false;
        const value = line_item ? line_item.quantity : parseInt(input.value, 10);
        if (value > 0) {
          const targetQuantity = 0;
          const lineKey = input.dataset.lineKey;
          item.dispatchEvent(
            new CustomEvent("line-item:will-change", {
              bubbles: true,
              detail: { targetQuantity },
            })
          );
          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );
          const cartContent = await (
            await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: lineKey,
                quantity: targetQuantity,
                sections: sectionsToBundle,
              }),
            })
          ).json();
          if (location.href.includes('cart')) {
            location.reload();
          }
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "line-item:change",
                cart: cartContent,
              },
            })
          );
        }
      }
    })
  }
}

document.addEventListener("cart:change", (event) => {
  checkRestrictedQuantities(event.detail['cart']);
});
document.addEventListener("DOMContentLoaded", (event) => {
  checkRestrictedQuantities(false);
});

document.addEventListener("cart:change", (event) => {
  checkResctrictedProducts(event.detail["cart"]);
});
document.addEventListener("DOMContentLoaded", (event) => {
  checkResctrictedProducts(false);
});